import { httpClient } from '@/services/http/httpClient'

type UpdatePositionPortfolioProjectData = {
  portfolioProjectId: string
  positionOnColumn: number
  portfolioColumnId: string
  portfolioId: string
}

export async function updatePositionPortfolioProject({
  portfolioProjectId,
  positionOnColumn,
  portfolioColumnId,
  portfolioId,
}: UpdatePositionPortfolioProjectData) {
  return await httpClient.put(
    `/projects/portfolio-projects/${portfolioId}/${portfolioProjectId}/position`,
    {
      positionOnColumn,
      portfolioColumnId,
    },
  )
}
